"use client";

import { useState, useEffect, useCallback } from "react";

/**
 * Wraps the static content sections on the generator page.
 * Hides children when ?country= and ?service= query params are present,
 * so the dynamic (country+service-specific) content isn't buried under
 * generic repeated sections.
 */
export default function GeneratorStaticContent({
  children,
}: {
  children: React.ReactNode;
}) {
  const [hidden, setHidden] = useState(false);

  const checkParams = useCallback(() => {
    const params = new URLSearchParams(window.location.search);
    setHidden(!!params.get("country") && !!params.get("service"));
  }, []);

  useEffect(() => {
    checkParams();

    const handleGeneratorChange = (e: Event) => {
      const { country, service } = (e as CustomEvent).detail || {};
      setHidden(!!country && !!service);
    };

    window.addEventListener("popstate", checkParams);
    window.addEventListener("generatorchange", handleGeneratorChange);
    return () => {
      window.removeEventListener("popstate", checkParams);
      window.removeEventListener("generatorchange", handleGeneratorChange);
    };
  }, [checkParams]);

  if (hidden) return null;

  return <>{children}</>;
}
